module.exports = __webpack_public_path__ + "static/icons/back-imagen-1.aa33a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/general/back-imagen-1.jpg
// module id = dI45
// module chunks = 1